module.exports = __webpack_public_path__ + "static/media/transpRollet.42c3021a.jpeg";